/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackLangViewModel } from "../types/FeedbackLangViewModel.ts";

export const feedbackLangViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  feedbackId: z.optional(z.number().int()),
  feedbackTitle: z.string().nullish(),
  description: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  cultureDisplayName: z.string().nullish(),
}) as unknown as ToZod<FeedbackLangViewModel>;
